import { isRxNeeded } from '../Common/Utility/common-utils';
import { PAGE_NAME } from '@common/Constants/analytics';
import {
  ONE_ASTER_CATEGORY,
  ASTER_PRODUCT_TYPES,
  PAYMENT_CURRENCY,
  SEND_VIEW_ITEM_LIST_EVENT,
  SEND_SELECT_ITEM_EVENT,
  SEND_CART_EVENT,
  SEND_VIEW_ITEM_EVENT,
  SCREEN_NAME,
  HOMECARE,
  HOMECARE_SEARCH_RESULT
} from '../Common/Utility/constants';
import { dataLayerSendEvent as sendEventData } from '../Common/Utility/analytics-utils';
import { getCurrency } from '@common/Constants/analytics';
import { getDataFromCookie } from 'aster-foundation/core/common/utils/cookieHelper';
import { getCurrencyFromRegion } from 'Epharmacy/EpharmacyAnalytics';

export const dataLayerSendEvent = (eventName, data) => {
  sendEventData(eventName, data);
};
// ! checkout page event

export const checkoutPageEvent = (data) => {
  const parameter = {
    currency: 'AED',
    screen_name: 'homecare-checkout',
    page_type: 'checkout page',
    purchase_type: 'Homecare',
    service_type: null,
    ...data,
  };
  dataLayerSendEvent('begin_checkout', parameter);
};

export const genderLayerSendEvent = (gender) => {
  const parameter = {
    gender: gender,
    screen_name: 'Homecare-checkout',
    page_type: 'Checkout Page',
    purchase_type: 'Homecare',
  };
  dataLayerSendEvent('gender_preference', parameter);
};

export const uploadDocumentLayerSendEvent = (data) => {
  const parameter = {
    screen_name: 'HomeCare-checkout',
    page_type: 'Checkout Page',
    purchase_type: 'Homecare',
    ...data,
  };
  dataLayerSendEvent('upload_documents', parameter);
};

export const uploadDocumentErrorEvent = (data) => {
  const parameter = {
    screen_name: 'homecare-checkout',
    page_type: 'Checkout Page',
    purchase_type: 'Homecare',
    ...data,
  };
  dataLayerSendEvent('upload_documents_error', parameter);
};

export const checkoutPayEvent = () => {
  const parameter = {
    purchase_type: 'Homecare',
    screen_name: 'Checkout - Homecare',
    page_type: 'Checkout page',
    service_type: null,
  };
  dataLayerSendEvent('checkout_pay', parameter);
};

export const homeCareBookingEventSuccess = (data) => {
  const parameter = {
    purchase_type: 'Homecare',
    screen_name: 'Homecare - Checkout page',
    page_type: 'Checkout Page',
    ...data,
  };
  dataLayerSendEvent('homecare_booking', parameter);
};
export const homeCareBookingEventError = (data) => {
  const parameter = {
    purchase_type: 'Homecare',
    screen_name: 'Homecare - Checkout page',
    page_type: 'Checkout Page',
    ...data,
  };
  dataLayerSendEvent('homecare_booking_error', parameter);
};

// ! Confirmation Page event
const getPaymentType = (data) => {
  if (data === 'Pay at Clinic') {
    return 'Pay at Clinic';
  } else if (data?.isPaymentCardExists) {
    return 'SAVED CARD';
  } else {
    return 'Pay via Credit/Debit Card';
  }
};

export const paymentInfoEvent = (paymentResponse, data, status) => {
  const parameter = {
    error: status === 'Fail' ? 'Payment could not be processed' : '',
    currency: PAYMENT_CURRENCY,
    value: Number(paymentResponse?._embedded?.payment[0]?.amount?.value) / 100,
    coupon: '',
    screen_name: 'Homecare Confirmation Page',
    page_type: 'Confirmation Page',
    referrer_page: 'Checkout - Homecare',
    purchase_type: ONE_ASTER_CATEGORY.HOMECARE,
    payment_type: getPaymentType(paymentResponse),
    payment_status: status,
    ...data,
  };
  dataLayerSendEvent('add_payment_info', parameter);
};

export const purchaseEvent = (data) => {
  const parameter = {
    currency: 'AED',
    coupon: '',
    shipping: '0',
    tax: '',
    loyalty_points_used: '',
    purchase_type: 'Homecare',
    screen_name: 'Homecare Confirmation',
    page_type: 'Order Confirmation',
    secure_points_used: 'False',
    ...data,
  };
  dataLayerSendEvent('purchase', parameter);
};

export const goToMyAppointmentEvent = () => {
  const parameter = {
    screen_name: 'Homecare Confirmation page',
    page_type: 'Confirmation page',
  };
  dataLayerSendEvent('go_to_my_appointment', parameter);
};

export const appointmentDetailEvent = (data, service, screenName) => {
  const parameter = {
    appointment_date: data?.date,
    appointment_time: data?.time,
    package_name: data?.packages,
    service_name: data?.services,
    booking_id: data?.bookingId,
    service_type: 'NA',
    screen_name: screenName,
  };
  dataLayerSendEvent('appointment_view_detail', parameter);
};

export const cancelAppointmentEvent = (reason_of_cancel, data) => {

  const services = data?.requiredData?.appointmentDetail?.appointmentDetails[0]?.services;
  const serviceNames = services.map(service => service?.name);

  const parameter = {
    booking_id: data?.requiredData?.bookingId,
    purchase_type: ONE_ASTER_CATEGORY.HOMECARE,
    service_type: data?.selectedServices,
    service_name: serviceNames,
    screen_name: 'Cancel Appointment',
    page_type: 'Cancel Appointment',
    payment_amount: data?.requiredData?.appointmentDetail?.paymentDetails?.totalAmount,
    reason_of_cancel: reason_of_cancel,
  };
  dataLayerSendEvent('cancel_appointment', parameter);
};
// ! cart page event
export const viewCartPageEvent = (data) => {
  const parameter = {
    screen_name: 'Homecare Cart Page',
    page_type: 'cart page',
    purchase_type: 'Homecare',
    ...data,
  };
  dataLayerSendEvent('view_cart', parameter);
};
export const slotSelectionEvent = (data) => {
  const parameter = {
    screen_name: 'Homecare Cart Page',
    page_type: 'Homecare Cart Page',
    purchase_type: 'Homecare',
    ...data,
  };
  dataLayerSendEvent('slot_selection', parameter);
};
export const slotSelectionError = (data) => {
  const parameter = {
    screen_name: 'Homecare Cart Page',
    page_type: 'Homecare Cart Page',
    purchase_type: 'Homecare',
    ...data,
  };
  dataLayerSendEvent('slot_selection_error', parameter);
};

export const viewMoreSlotsEvent = () => {
  const parameter = {
    screen_name: 'Homecare Cart Page',
    product_type: 'Homecare',
    page_type: 'Homecare Cart Page',
  };
  dataLayerSendEvent('view_more_slots', parameter);
};

export const addToWishlistEvent = (data) => {
  const parameter = {
    currency: 'AED',
    section_name: 'Homecare Cart Page',
    product_type: 'Homecare',
    page_type: 'Homecare Cart Page',
    screen_name: 'Homecare Cart Page',
    ...data,
  };
  dataLayerSendEvent('add_to_wishlist', parameter);
};

export const removeFromCartEvent = (data) => {
  const parameter = {
    currency: 'AED',
    section_name: 'Homecare Cart Page',
    product_type: 'Homecare',
    page_type: 'Homecare Cart Page',
    screen_name: 'Homecare Cart Page',
    ...data,
  };
  dataLayerSendEvent('remove_from_cart', parameter);
};

export const sendShareEvent = (detailsData, shareOption = '') => {
  const itemData = {
    product_name: detailsData?.name,
    currency: PAYMENT_CURRENCY,
    service_type: detailsData?.dataType === 'Packages' ? 'Package only' : 'Service only',
    product_type: ASTER_PRODUCT_TYPES.HOMECARE,
    page_type: 'Product Details page',
    screen_name: detailsData?.name,
    rx_required: isRxNeeded(detailsData),
  };
  
  dataLayerSendEvent('share_product_details', itemData);

};

export const getItemsObject = (product, list_id = '', list_name = '', priceValue, eventName, service_type) => {
  const itemCategories = {};
  if (product?.ServiceCategories) {
    product?.ServiceCategories?.map((category, i) => {
      if (i < 5) {
        if (i === 0) {
          itemCategories.item_category = category.name;
        } else if (product?.ServiceCategories[i - 1]) {
          itemCategories[`item_category${i + 1}`] = category.name;
        }
      }
      return i;
    });
  }

  const baseParams = {
    item_id: product?.hisid?.toString(),
    item_name: product?.name,
    currency: getCurrencyFromRegion(),
    discount: 0,
    price: product?.price ? product?.price[0]?.salesPrice : priceValue,
    quantity: 1,
    ...itemCategories,
  };

  if (eventName === 'sendViewItemListEvent'){
    return {
      item_list_id: list_id,
      item_list_name: list_name,
      service_type: service_type,
      ...baseParams,
    };
  } else if (eventName === 'sendSelectItemEvent'){
    return {
      item_list_id: list_id,
      item_list_name: list_name,
      ...baseParams,
    };
  } else if (eventName === 'sendViewItemEvent'){
    return {
      ...baseParams
    };
  } else if (eventName === 'sendCartEvent'){
      if(priceValue !== 0){
        return {
          ...baseParams
        };
      }else{
        return {
          item_list_id: list_id,
          ...baseParams,
        };
      } 
  } else {
    return {
      coupon: '',
      item_list_id: list_id,
      item_list_name: list_name,
      ...baseParams,
    };
  }
};

export const sendViewItemListEvent = ({items = [], listName, listId, serviceType, pageName = '', query = ''}) => {
  const itemData = {
    product_type: ASTER_PRODUCT_TYPES.HOMECARE,
    ...(query && { search_term: query }),
    ...(query && { myaster_category: HOMECARE }),
    page_type: query ? PAGE_NAME.SEARCH_LANDING_PAGE : PAGE_NAME.ASCO,
    screen_name: pageName === ASTER_PRODUCT_TYPES.HOMECARE ? SCREEN_NAME.HC : query !== '' ? HOMECARE_SEARCH_RESULT : SCREEN_NAME.ASCO,
    section_name: listName,
    ecommerce: {
      items: items?.map((element, index) => ({ ...getItemsObject(element, listId, listName, 0, SEND_VIEW_ITEM_LIST_EVENT, serviceType), index: index + 1 })),
    },
  };
  dataLayerSendEvent('view_item_list', itemData);
};

export const sendSelectItemEvent = (data) => {

  const itemData = {
    ecommerce: {
      items: [{ ...getItemsObject(data.item, data?.itemListId, data?.itemListName, 0, SEND_SELECT_ITEM_EVENT, data?.pageType), index: 1 }],
    },
    product_type: ASTER_PRODUCT_TYPES.HOMECARE,
    section_name: data?.pageName === 'Product Listing Page' ? '' : data?.itemListName,
    rx_required: isRxNeeded(data?.item),
    page_type: data?.pageName === ASTER_PRODUCT_TYPES.HOMECARE ? 'homepage' : 'product listing page',
    screen_name: data?.pageName === ASTER_PRODUCT_TYPES.HOMECARE ? 'homecare homepage' : data?.pageName === 'Product Listing Page' ? data?.itemListName : 'asco homepage',
    service_type: data?.pageType,
    currency: getCurrency(getDataFromCookie('regionCode')),
  };
  dataLayerSendEvent('select_item', itemData);
};

export const sendCartEvent = (item, isPackage, pageName, itemListId, screen_name, isAddToCart, priceValue = 0) => {

  const itemData = {
    ecommerce: {
      items: [{ ...getItemsObject(item, itemListId, screen_name, priceValue, SEND_CART_EVENT), index: 1 }],
    },
    currency: PAYMENT_CURRENCY,
    value: priceValue !== 0 ? priceValue : item?.price[0]?.salesPrice,

    ...(priceValue === 0 && { section_name: screen_name }),

    service_type: isPackage ? 'Package only' : 'Service only',
    product_type: ASTER_PRODUCT_TYPES.HOMECARE,
    page_type: pageName === ASTER_PRODUCT_TYPES.HOMECARE ? 'homepage' : pageName.toLowerCase(),
    screen_name: pageName === ASTER_PRODUCT_TYPES.HOMECARE ? 'homecare homepage' : screen_name,
    rx_required: isRxNeeded(item),
  };
  if (isAddToCart) {
    dataLayerSendEvent('add_to_cart', itemData);
  } else {
    dataLayerSendEvent('remove_from_cart', itemData);
  }
};

export const sendWhislistEvents = (item, isPackage, pageName, itemListId, screen_name, isAddToWhislist) => {
  const itemData = {
    currency: PAYMENT_CURRENCY,
    value: 100,
    section_name: screen_name,
    service_type: isPackage ? 'Package only' : 'Service only',
    product_type: ASTER_PRODUCT_TYPES.HOMECARE,
    page_type: pageName === ASTER_PRODUCT_TYPES.HOMECARE ? 'Homepage - Homecare' : pageName,
    screen_name: pageName === ASTER_PRODUCT_TYPES.HOMECARE ? 'Homepage - Homecare' : screen_name,
    rx_required: isRxNeeded(item),
  };
  if (isAddToWhislist) {
    itemData.ecommerce = {
      items: { ...getItemsObject(item, itemListId, screen_name), index: 1 },
    };
    dataLayerSendEvent('add_to_wishlist', itemData);
  } else {
    itemData.product_name = item?.name;
    dataLayerSendEvent('remove_from_wishlist', itemData);
  }
};

export const sendRxBottomSheet = (isPackage, pageName, screen_name, optionSelected) => {
  const itemData = {
    screen_name: pageName === ASTER_PRODUCT_TYPES.HOMECARE ? 'Homepage - Homecare' : screen_name,
    section_name: screen_name,
    service_type: isPackage ? 'Package only' : 'Service only',
    product_type: ASTER_PRODUCT_TYPES.HOMECARE,
    page_type: pageName === ASTER_PRODUCT_TYPES.HOMECARE ? 'Homepage - Homecare' : pageName,
    option: optionSelected,
  };
  dataLayerSendEvent('rx_bottom_sheet', itemData);
};

export const sendViewItemEvent = (detailData, priceValue = 0) => {

  const itemData = {
    ecommerce: {
      items: [{ ...getItemsObject(detailData, detailData?.id, detailData?.name, priceValue, SEND_VIEW_ITEM_EVENT), index: 1 }],
    },
    currency: getCurrencyFromRegion(),
    value: priceValue,
    
    ...(priceValue === 0 && { section_name: detailData?.name }),

    service_type: detailData?.dataType === 'Packages' ? 'Package only' : 'Service only',
    product_type: ASTER_PRODUCT_TYPES.HOMECARE,
    page_type: 'Product Details page',
    screen_name: detailData?.name,
    rx_required: isRxNeeded(detailData),
  };
  dataLayerSendEvent('view_item', itemData);
};

// ! Rx_upload Event

export const uploadRxEvent = () => {
  const item = {
    screen_name: 'Homecare - rxupload',
    page_type: 'rxupload page',
    product_type: 'Homecare',
  };
  dataLayerSendEvent('upload_rx', item);
};

export const requestConsultationEvent = () => {
  const item = {
    screen_name: 'Homecare - rxupload',
    page_type: 'rxupload page',
    product_type: 'Homecare',
  };
  dataLayerSendEvent('request_consultation', item);
};

export const rxCheckoutEvent = (data) => {
  const item = {
    screen_name: 'Homecare - rxupload',
    page_type: 'rxupload page',
    product_type: 'Homecare',
    payment_method: data,
  };
  dataLayerSendEvent('rx_checkout', item);
};

// ! After booking feedback Event

export const feedbackSubmitEvent = (data) => {
  const parameter = {
    screen_name: 'Homecare Feedback Page',
    page_type: 'Service Completion Feedback',
    product_type: 'Homecare',
    ...data,
  };
  dataLayerSendEvent('share_feedback', parameter);
};

export const feedbackSkipEvent = (data) => {
  const parameter = {
    screen_name: 'Homecare Feedback Page',
    page_type: 'Service Completion Feedback',
    product_type: 'Homecare',
    ...data,
  };
  dataLayerSendEvent('skip_feedback', parameter);
};

export const paymentCancelledOrFailedEvent = (data) => {
  const parameter = {
    purchase_type: 'Homecare',
    payment_type: 'Credit card',
    ...data,
  };
  dataLayerSendEvent('payment_cancelled_or_failed', parameter);
};

// ! Homecare Home page event

export const uploadPrescriptionEvent = () => {
  const parameter = {
    screen_name: 'Homecare Home Page',
    page_type: 'homepage',
    product_type: 'Homecare',
    myaster_category: 'epharmacy'
  };
  dataLayerSendEvent('upload_prescription', parameter);
};

export const dataLayerSendPageViewEvent = (data) => {
  const parameter = {
    oneaster_category: 'Homecare',
    ...data,
  };
  dataLayerSendEvent('page_view', parameter);
};
export const changeLocationEvent = (data) => {
  const parameter = {
    oneaster_category: 'Homecare',
    ...data,
  };
  dataLayerSendEvent('change_location', parameter);
};
export const dataLayerSendPageViewHomeCareEvent = (eventName, siteWideData, userLogin = false, data) => {
  const userArea = localStorage.getItem('userArea');
  const dataLayerOptions = {
    page_type: siteWideData?.page_type,
    screen_name: siteWideData?.screen_name,
    area: userArea,
    user_state: userLogin ? 'Logged In' : 'Guest',
    oneaster_category: "Homecare",
    ...data,
  };
  dataLayerSendEvent(eventName, dataLayerOptions);
};
// ! Home care primary menu click
export const primaryMenuClickEvent = (data) => {
  const parameter = {
    ...data,
  };
  dataLayerSendEvent('primary_menu_click', parameter);
};

export const rescheduleAppointmentEvent = (services, id, data, time) => {
  const parameter = {
    purchase_type: 'Homecare',
    screen_name: 'Reschedule Appointment',
    page_type: 'Reschedule Appointment',
    service_type: services[0]?.dataType,
    payment_amount: data,
    booking_id: id,
    appointment_date: time,
    ...data,
  };
  dataLayerSendEvent('reschedule_appointment', parameter);
};
// ! lists_view event in shopping list
export const listsViewEvent = (data) => {
  const parameter = {
    option: 'Homecare',
    ...data,
  };
  dataLayerSendEvent('lists_view', parameter);
};

export const homecareIconClick = (location) => {
  const itemData = {
    button_name: 'Homecare Homepage',
    button_location: location,
  };
  dataLayerSendEvent('homecare_button_clicked', itemData);
};


export function transformAnalyticData(analyticData) {
  return analyticData?.consignments[0]?.bookedservices.map(item => {
      return {
          item_id: item?.typeId,
          item_name: item?.serviceName,
          price: parseFloat(item?.price),
          item_category: item?.type,
          quantity: 1,
          currency: 'AED',
      };
  });
}